/* eslint-disable no-param-reassign */
import {
  IRaffleDefaultProfitTypeDTO,
  IRaffleDefaultTypeDTO,
} from "@hooks/dtos/raffles/IRaffleDefaultDTO";
import {
  IRaffleProfitType,
  IRaffleType,
} from "@hooks/dtos/raffles/IRaffleGeneralDTO";

const raffleTypes: IRaffleDefaultTypeDTO[] = [
  {
    type: "default_number",
    text: "Trad. Numérica",
    title: "Rifa Tradicional Numérica",
    color: "success",
  },
  {
    type: "default_word",
    text: "Trad. Palavra",
    title: "Rifa Tradicional de Palavras ou Nomes",
    color: "success",
  },
];

function getRaffleType(type: IRaffleType): IRaffleDefaultTypeDTO {
  let ret = raffleTypes.find((raffleType) => raffleType.type === type);
  if (!ret) ret = { type: "", text: "Error", title: "Error", color: "danger" };
  return ret;
}

const raffleProfitTypes: IRaffleDefaultProfitTypeDTO[] = [
  {
    type: "total",
    title: "Embaixador",
    text: "Lucro total sobre a venda dos tickets (sem nenhuma taxa).",
    color: "success",
  },
  {
    type: "profited",
    title: "Tradicional",
    text: "Lucro sobre a venda de tickets, com exceção de taxas externas.",
    color: "success",
  },
  {
    type: "partner",
    title: "Parceria",
    text: "Parceria com a plataforma, repassando parte do lucro da venda de tickets.",
    color: "success",
  },
];

function getRaffleProfitType(
  type: IRaffleProfitType
): IRaffleDefaultProfitTypeDTO {
  let ret = raffleProfitTypes.find(
    (raffleProfitType) => raffleProfitType.type === type
  );
  if (!ret) ret = { type: "", text: "Error", title: "Error", color: "danger" };
  return ret;
}

export { raffleTypes, getRaffleType, getRaffleProfitType };
